import { brlPrice } from '@/filters/currency'

export default (plan) => {
  let item = '';
  if (plan.installments_number === 1){
    item = plan.installments_number + 'x ' + brlPrice(plan.installments[0].amount)
  }
  if (plan.installments_number === 2){
    item = plan.installments_number + 'x ' + brlPrice(plan.installments[0].amount) + ' na primeira parcela, ' + brlPrice(plan.installments[1].amount) + ' na segunda'
  }
  if (plan.installments_number > 2){
    item = plan.installments_number + 'x ' + brlPrice(plan.installments[0].amount) + ' na primeira parcela, ' + brlPrice(plan.installments[1].amount) + ' nas demais'
  }
  return item
}
